import { createAction } from "@reduxjs/toolkit";

import {
  FETCH,
  DONE,
  FAIL,
  GET,
  EDIT,
  RESET,
  DELETE,
  POST,
  ONE,
  SCHEDULE,
  PSYCHOLOGIST,
  WORK,
  FILTER,
  GROUPS,
  STUDENT,
  TEACHERS
} from "../../constants";

export const getPsychologistSchedule = createAction<undefined>(GET + PSYCHOLOGIST + SCHEDULE + FETCH);
export const getPsychologistScheduleDone = createAction<any>(GET + PSYCHOLOGIST + SCHEDULE + FETCH + DONE);
export const getPsychologistScheduleFail = createAction<undefined>(GET + PSYCHOLOGIST + SCHEDULE + FETCH + FAIL);

export const getPsychologistScheduleByID = createAction<any>(GET + PSYCHOLOGIST + SCHEDULE + ONE + FETCH);
export const getPsychologistScheduleByIDDone = createAction<any>(GET + PSYCHOLOGIST + SCHEDULE + ONE + FETCH + DONE);
export const getPsychologistScheduleByIDFail = createAction<undefined>(GET + PSYCHOLOGIST + SCHEDULE + ONE + FETCH + FAIL);

export const postPsychologistSchedule = createAction<any>(POST + PSYCHOLOGIST + SCHEDULE);
export const postPsychologistScheduleDone = createAction<any>(POST + PSYCHOLOGIST + SCHEDULE + DONE);
export const postPsychologistScheduleFail = createAction<undefined>(POST + PSYCHOLOGIST + SCHEDULE + FAIL);
export const postPsychologistScheduleReset = createAction<undefined>(POST + PSYCHOLOGIST + SCHEDULE + RESET);

export const putPsychologistSchedule = createAction<any>(EDIT + PSYCHOLOGIST + SCHEDULE);
export const putPsychologistScheduleDone = createAction<any>(EDIT + PSYCHOLOGIST + SCHEDULE + DONE);
export const putPsychologistScheduleFail = createAction<undefined>(EDIT + PSYCHOLOGIST + SCHEDULE + FAIL);
export const putPsychologistScheduleReset = createAction<undefined>(EDIT + PSYCHOLOGIST + SCHEDULE + RESET);

export const deletePsychologistSchedule = createAction<any>(DELETE + PSYCHOLOGIST + SCHEDULE);
export const deletePsychologistScheduleDone = createAction<any>(DELETE + PSYCHOLOGIST + SCHEDULE + DONE);
export const deletePsychologistScheduleFail = createAction<undefined>(DELETE + PSYCHOLOGIST + SCHEDULE + FAIL);

export const getPsychologistWork = createAction<any>(PSYCHOLOGIST + WORK + FETCH);
export const getPsychologistWorkDone = createAction<any>(PSYCHOLOGIST + WORK + FETCH + DONE);
export const getPsychologistWorkFail = createAction<undefined>(PSYCHOLOGIST + WORK + FETCH + FAIL);

export const getPsychologistWorkByOne = createAction<any>(PSYCHOLOGIST + WORK + ONE + FETCH);
export const getPsychologistWorkByOneDone = createAction<any>(PSYCHOLOGIST + WORK + ONE + FETCH + DONE);
export const getPsychologistWorkByOneFail = createAction<undefined>(PSYCHOLOGIST + WORK + ONE + FETCH + FAIL);

export const postPsychologistWork = createAction<any>(POST + PSYCHOLOGIST + WORK);
export const postPsychologistWorkDone = createAction<any>(POST + PSYCHOLOGIST + WORK + DONE);
export const postPsychologistWorkFail = createAction<undefined>(POST + PSYCHOLOGIST + WORK + FAIL);
export const postPsychologistWorkReset = createAction<undefined>(POST + PSYCHOLOGIST + WORK + RESET);

export const putPsychologistWork = createAction<any>(EDIT + PSYCHOLOGIST + WORK);
export const putPsychologistWorkDone = createAction<any>(EDIT + PSYCHOLOGIST + WORK + DONE);
export const putPsychologistWorkFail = createAction<undefined>(EDIT + PSYCHOLOGIST + WORK + FAIL);
export const putPsychologistWorkReset = createAction<undefined>(EDIT + PSYCHOLOGIST + WORK + RESET);

export const deletePsychologistWork = createAction<any>(DELETE + PSYCHOLOGIST + WORK);
export const deletePsychologistWorkDone = createAction<any>(DELETE + PSYCHOLOGIST + WORK + DONE);
export const deletePsychologistWorkFail = createAction<undefined>(DELETE + PSYCHOLOGIST + WORK + FAIL);

export const getPsychologistWorkFilter = createAction<undefined>(PSYCHOLOGIST + WORK + FILTER + FETCH);
export const getPsychologistWorkFilterDone = createAction<any>(PSYCHOLOGIST + WORK + FILTER + FETCH + DONE);
export const getPsychologistWorkFilterFail = createAction<undefined>(PSYCHOLOGIST + WORK + FILTER + FETCH + FAIL);

export const getPsychologistWorkGroup = createAction<undefined>(PSYCHOLOGIST + WORK + GROUPS + FETCH);
export const getPsychologistWorkGroupDone = createAction<any>(PSYCHOLOGIST + WORK + GROUPS + FETCH + DONE);
export const getPsychologistWorkGroupFail = createAction<undefined>(PSYCHOLOGIST + WORK + GROUPS + FETCH + FAIL);

export const getPsychologistWorkGroupStudents = createAction<any>(PSYCHOLOGIST + WORK + GROUPS + STUDENT + FETCH);
export const getPsychologistWorkGroupStudentsDone = createAction<any>(PSYCHOLOGIST + WORK + GROUPS + STUDENT + FETCH + DONE);
export const getPsychologistWorkGroupStudentsFail = createAction<undefined>(PSYCHOLOGIST + WORK + GROUPS + STUDENT + FETCH + FAIL);

export const getPsychologistTeachers = createAction<undefined>(PSYCHOLOGIST + TEACHERS + FETCH);
export const getPsychologistTeachersDone = createAction<any>(PSYCHOLOGIST +TEACHERS + FETCH + DONE);
export const getPsychologistTeachersFail = createAction<undefined>(PSYCHOLOGIST + TEACHERS + FETCH + FAIL);